import { useState } from "react";
import { useParams } from "react-router-dom";
import CustomDataGridV2 from "../../../../../../../components/CustomDataGridV2";
import Flex from "../../../../../../../components/Flex";
import PdfViewDrawer from "../../../../../../../components/PdfViewDrawer";
import ActionMenu from "../../../../../../../components/app/ActionMenu";
import ChartTableWrapper from "../../../../../../../components/app/provider/patient/add-new-patient/ChartTableWrapper";
import useDisclosure from "../../../../../../../hooks/use-disclosure";
import { downloadPdf } from "../../../../../../../hooks/use-download-pdf";
import { usePatientAssessmentList } from "../../../../../../../queries/patient-chart/assessment/use-assessment-get";
import { usePatientAssessmentPdfDownload } from "../../../../../../../queries/patient-chart/assessment/use-assessment-pdf-download";
import { formatDateTime } from "../../../../../../../utils/date-time-utility";
import {
  DEF_PAGINATION,
  DGT_Pagination,
  applyDefaultColumnSettings,
  getXtenantId,
} from "../../../../../../../utils/utils";

const PatientSubmittedAssessmentNewTable = () => {
  const previewAssessment = useDisclosure();
  const [pagination, setPagination] = useState<DGT_Pagination>(DEF_PAGINATION);
  const { patientId } = useParams();

  const { data } = usePatientAssessmentList({
    pagination: pagination,
    gridSorting: [],
    patientId: patientId,
    xTENANTID: getXtenantId(),
  });

  const { mutateAsync: downloadAssessmentPdf } =
    usePatientAssessmentPdfDownload();

  const onDownloadClick = (
    row: any,
    patientId: string,
    type: "download" | "view"
  ) => {
    downloadAssessmentPdf({
      assessmentPDFRequest: {
        patientId: patientId,
        screeningAt: row.screeningAt,
        screeningBy: row.screeningBy,
        assessments: row.responses,
      },
      xTENANTID: getXtenantId(),
    }).then((res) => {
      const blob = new Blob([res?.data], { type: "application/pdf" });

      const fileUrl = URL.createObjectURL(blob);

      if (type === "view") {
        previewAssessment.open(fileUrl);
      } else downloadPdf(blob, `${row.assessmentName}.pdf`);
    });
  };

  const COLUMNS = applyDefaultColumnSettings<any>([
    {
      field: "name",
      headerName: "Assessment Name",
      flex: 0.6,
      width: 200,
      renderCell: ({ row }) => row?.assessmentName || "-",
    },
    {
      field: "screeningAt",
      headerName: "Sent On",
      flex: 0.5,
      width: 180,
      renderCell: ({ value }) => formatDateTime(value),
    },
    {
      field: "screeningBy",
      headerName: "Sent By",
      flex: 0.5,
      width: 150,
      renderCell: ({ value }) => value || "-",
    },
    {
      field: "Action",
      headerName: "Actions",
      width: 90,
      renderCell: ({ row }: any) => {
        return (
          <ActionMenu
            options={[
              { value: "view", label: "View" },
              { value: "download", label: "Download" },
            ]}
            onActionClick={(v) => {
              if (v === "view" || v === "download") {
                onDownloadClick(row, row?.patientId, v as "download" | "view");
              }
            }}
          />
        );
      },
    },
  ]);

  return (
    <Flex
      flexDirection={"column"}
      width={"100%"}
      height={"calc(100vh - 373px)"}
      gap={1}
    >
      <PdfViewDrawer
        w="65vw"
        file={previewAssessment?.data}
        disclosureHost={previewAssessment}
        title="Screening Assessment Report"
      />
      <ChartTableWrapper small={false}>
        <CustomDataGridV2
          getRowId={(row) => row?.uuid}
          rows={data?.data?.content ?? []}
          rowCount={data?.data?.page?.totalElements ?? 10}
          columns={COLUMNS}
          // sx={{ marginTop: "40px" }}
          disableRowSelectionOnClick
          paginationModel={pagination}
          onPaginationModelChange={setPagination}
        />
      </ChartTableWrapper>
    </Flex>
  );
};

export default PatientSubmittedAssessmentNewTable;
